import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import Link from 'next/link.js';
export const StyledAnchorBarItemLink = styled(Link, {
    shouldForwardProp: prop => isPropValid(prop) && prop !== 'isActive',
})(({ theme, isActive }) => ({
    textDecoration: 'none',
    marginLeft: 0,
    display: 'block',
    position: 'relative',
    padding: theme.spacing[300],
    span: {
        fontWeight: isActive ? theme.typography.h6.fontWeight : theme.typography.body.fontWeight,
    },
    '&:after': {
        position: 'absolute',
        content: '""',
        left: 0,
        right: 0,
        bottom: `-1px`,
        height: isActive ? '2px' : '1px',
        background: isActive
            ? theme.color.background.interactiveControlSelectedBase
            : theme.color.background.interactiveInverseDisabled,
    },
    '&:hover': {
        color: theme.color.font.interactiveBase,
        backgroundColor: theme.color.background.interactiveHovered,
        '&:after': {
            background: isActive
                ? theme.color.background.interactiveControlSelectedBase
                : theme.color.background.interactiveControlContrastHovered,
        },
    },
    '&:focus-visible': {
        outline: 0,
        span: {
            outlineWidth: theme.spacing[50],
            outlineStyle: 'solid',
            outlineOffset: theme.spacing[100],
            outlineColor: theme.color.border.interactiveMainHovered,
            borderRadius: theme.spacing[100],
        },
        backgroundColor: theme.color.background.interactiveInverseDisabled,
    },
}));
//# sourceMappingURL=AnchorBarItem.styles.js.map